// test520
(520 && 0);
